(function () {
    'use strict';

    angular
        .module('componentVisualGuidelinesControllers', [
            'services.env',
            'services.esbEmployees'
        ]);
})();
